import { FunctionComponent } from 'react';
import { MinutesSelect } from '../minutes-select';
import { HourSelect } from '../hour-select';
import { TabCronProp } from '@/types/cron';

const WeeklyCron: FunctionComponent<TabCronProp> = (props) => {

    const onAtHourChange = (e: { target: { value: string; }; }) => {
        if (props.disabled) { return }
        const val = props.value;
        val[0] = '0';
        val[2] = `${e.target.value}`;
        props.onChange(val);
    }

    const onAtMinuteChange = (e: { target: { value: string; }; }) => {
        if (props.disabled) { return }
        const val = props.value;
        val[0] = '0';
        val[1] = `${e.target.value}`;
        props.onChange(val);
    }

    const onCheck = (e: { target: { checked: boolean, value: string; }; }) => {
        if (props.disabled) { return }
        const val = props.value;
        val[0] = '0';
        if (e.target.checked) {
            onDayChecked(val, e);
        } else {
            onDayUnChecked(val, e);
        }
        props.onChange(val)
    }

    const onDayChecked = (val: string[], e: { target: { checked: boolean, value: string } }) => {
        val[2] = (`${val[2]}`.split('/').length > 1) ? '0' : val[2].toString();
        val[3] = '?';
        val[4] = '*';
        if (val[5] === '*' || val[5] === '?' || val[5] === 'MON-FRI') {
            val[5] = e.target.value;
        } else {
            val[5] = val[5] + '!' + e.target.value;
        }
    }

    const onDayUnChecked = (val: string[], e: { target: { checked: boolean, value: string } }) => {
        let valFive: string | string[] = val[5]?.split('!');
        if (valFive.length > 1) {
            valFive.splice(valFive.indexOf(e.target.value), 1);
            valFive = valFive.toString().replace(/,/g, '!');
        }
        else {
            valFive = '*';
        }
        val[5] = valFive
    }

    return (
        <div className="container-fluid py-4">
            <div className='text-left font-semibold text-base mb-1'>
                Every
            </div>
            <div className='w-full flex flex-row space-between'>
                <div className='w-1/2 flex flex-col items-start'>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="MON"
                            onChange={onCheck}
                            checked={(props.value[5].search('MON') !== -1) ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Monday')}
                        </label>
                    </div>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="WED"
                            onChange={onCheck}
                            checked={props.value[5].search('WED') !== -1 ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Wednesday')}
                        </label>
                    </div>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="FRI"
                            onChange={onCheck}
                            checked={(props.value[5].search('FRI') !== -1) ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Friday')}
                        </label>
                    </div>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="SUN"
                            onChange={onCheck}
                            checked={props.value[5].search('SUN') !== -1 ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Sunday')}
                        </label>
                    </div>
                </div>
                <div className='w-1/2 flex flex-col items-start'>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="TUE"
                            onChange={onCheck}
                            checked={props.value[5].search('TUE') !== -1 ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Tuesday')}
                        </label>
                    </div>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="THU"
                            onChange={onCheck}
                            checked={props.value[5].search('THU') !== -1 ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Thursday')}
                        </label>
                    </div>
                    <div className='flex items-center mb-2'>
                        <input
                            className='h-[18px] w-[18px] mr-2 cursor-pointer'
                            id='weekDaysCheckbox'
                            type="checkbox"
                            value="SAT"
                            onChange={onCheck}
                            checked={props.value[5].search('SAT') !== -1 ? true : false}
                            disabled={props.disabled}
                        />
                        <label htmlFor="weekDaysCheckbox" className='cursor-pointer text-base'>
                            {props.translate('Saturday')}
                        </label>
                    </div>
                </div>
            </div>
            <div className='my-4' />
            <div className='text-left font-semibold text-base mb-1'>
                Start Time
            </div>
            <div className='w-full flex flex-row items-center'>
                <HourSelect
                    onChange={onAtHourChange}
                    value={props.value[2]}
                    disabled={props.disabled}
                />
                <div className='mx-4 font-bold'>:</div>
                <MinutesSelect
                    onChange={onAtMinuteChange}
                    value={props.value[1]}
                    disabled={props.disabled}
                />
            </div>
        </div>
    )
}

export default WeeklyCron;
